import '../v2/index.js'
import '../v2/index.scss'

// Same wait-then-dispatch pattern as customer_side.js: Turbolinks may
// fire `turbolinks:load` later on its own, so only dispatch manually
// if nothing arrives within ~50ms.
;(() => {
  if (document.readyState === 'loading') return
  let nativeFired = false
  const markFired = () => { nativeFired = true }
  document.addEventListener('turbolinks:load', markFired, { once: true })
  setTimeout(() => {
    if (!nativeFired) {
      document.removeEventListener('turbolinks:load', markFired)
      document.dispatchEvent(new Event('turbolinks:load'))
    }
  }, 50)
})()
